/**
* Include your custom JavaScript here.
*/


// ==========================================
// 2. LEGACY THEME CODE (WRAPPED IN TRY-CATCH)
// ==========================================
// Legacy collection filters
(function () {
  function getCollectionUrl() {
    var collectionUrlInput = document.querySelector(".input_wrapper");
    return collectionUrlInput && collectionUrlInput.value
      ? collectionUrlInput.value
      : window.location.pathname.split("?")[0];
  }

  function getSelectedFilterUrl(filters) {
    var selectedHandles = [];

    filters.querySelectorAll(".product_filters input:checked").forEach(function (input) {
      var handle = input.getAttribute("data-url");

      if (handle && selectedHandles.indexOf(handle) === -1) {
        selectedHandles.push(handle);
      }
    });

    var url = selectedHandles.length > 0
      ? getCollectionUrl() + "/" + selectedHandles.join("+")
      : getCollectionUrl();

    var currentUrl = new URL(window.location.href);
    var sortBy = currentUrl.searchParams.get("sort_by");

    if (sortBy) {
      url += "?sort_by=" + encodeURIComponent(sortBy);
    }

    return url;
  }

  async function applySelectedFilters(filters, event) {
    if (event) {
      event.preventDefault();
    }

    var filterUrl = getSelectedFilterUrl(filters);
    var currentCollectionMain = document.querySelector(".collection__main");

    if (!currentCollectionMain) {
      return;
    }

    currentCollectionMain.setAttribute("aria-busy", "true");

    try {
      var response = await fetch(filterUrl);
      var html = await response.text();
      var parsedDocument = new DOMParser().parseFromString(html, "text/html");
      var nextCollectionMain = parsedDocument.querySelector(".collection__main");

      if (nextCollectionMain) {
        currentCollectionMain.innerHTML = nextCollectionMain.innerHTML;
        history.replaceState({}, "", filterUrl);
      }

      document.querySelectorAll(".mobile_filter_drag.active").forEach(function (drawer) {
        drawer.classList.remove("active");
      });
    } catch (error) {
      console.error("[Legacy collection filters] Unable to load filtered products", error);
    } finally {
      currentCollectionMain.removeAttribute("aria-busy");
    }
  }

  document.addEventListener("click", function (event) {
    var openTrigger = event.target.closest(".mobile_filter > button.SortTags, .mobile_filter > svg");
    if (openTrigger) {
      event.preventDefault();

      var filters = openTrigger.closest(".legacy-collection-filters");
      var drawer = filters && filters.querySelector(".mobile_filter_drag");

      if (drawer) {
        drawer.classList.add("active");
      }

      return;
    }

    var closeTrigger = event.target.closest(".close_wrapper");
    if (closeTrigger) {
      event.preventDefault();

      var drawerToClose = closeTrigger.closest(".mobile_filter_drag");
      if (drawerToClose) {
        drawerToClose.classList.remove("active");
      }

      return;
    }

    var applyButton = event.target.closest(".Button--apply");
    if (applyButton) {
      var filtersForApply = applyButton.closest(".legacy-collection-filters");

      if (filtersForApply) {
        applySelectedFilters(filtersForApply, event);
      }
    }
  });

  document.addEventListener("change", function (event) {
    var input = event.target.closest(".legacy-collection-filters .product_filters input");

    if (!input) {
      return;
    }

    var filters = input.closest(".legacy-collection-filters");

    if (filters) {
      applySelectedFilters(filters);
    }
  });
})();


try {
  if (typeof $ !== 'undefined' && $.fn && $.fn.flickity) {    
    $('.AnnouncementBar__Wrapper').flickity({
      "prevNextButtons": false,
      "setGallerySize": false,
      "adaptiveHeight": false,
      "wrapAround": true,
      "dragThreshold": 15,
      "pauseAutoPlayOnHover": false,
      "autoPlay": 3000,
      "pageDots": false
    });
  } else {
    console.warn("[KeyPO Custom] jQuery or Flickity not found, skipping slider init.");
  }

  if (typeof $ !== 'undefined') {
    $(".product_filters ul li").click(function(){
      var res = '';
      $(".product_filters ul li input:checked").each(function(){
        res += $(this).attr("data-url")+'+';
      });   
      res = res.substring(0,  res.length - 1);
      var collurl = $(".input_wrapper").val();
      var final =  collurl+'/'+res;
      $.ajax({
          url:  final,
          type: 'GET',
          dataType: 'html'
        })
        .done(function(data) {
          var finalot = $(data).find(".CollectionInner .CollectionInner__Products").html();
          $(".CollectionInner .CollectionInner__Products").html(finalot);
          $(".js .features--show-element-staggering .ProductList--grid .ProductItem").css("visibility","visible");
          if($(window).width()<= 749){
            $( ".mobile_filter_drag" ).removeClass( "active" );
          }
        }); 
    });

    $(document).ready(function(){
      $(".mobile_filter").click(function(){ $(".mobile_filter_drag").addClass("active"); });
      $(".close_wrapper").click(function(){ $( ".mobile_filter_drag" ).removeClass( "active" ); });
      $(".Button--apply").click(function(){ $( ".mobile_filter_drag" ).removeClass( "active" ); });
    });

    $(".rating").click(function() {
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#judgeme_product_reviews").offset().top
        }, 2000);
    });

    $(".radio-chk input[radio]").change(function(event){
      var p = $("#messageChk1:checked").val();
      if(p=="1"){
        $(".optional-cart-message").attr("required","required");
        $(".CartSpecialInstructions").attr("required","required");
      }else{
        $(".optional-cart-message").removeAttr("required");
        $(".CartSpecialInstructions").removeAttr("required");
      }
    });
  }
} catch(err) {
  console.error("[Legacy Code Error] Captured error to prevent crash:", err);
}

function isNumber(evt) {
  evt = (evt) ? evt : window.event;
  var charCode = (evt.which) ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }
  return true;
}

try {
  if (typeof $ !== 'undefined') {
    if($("[name='properties[Message For Engraving]']").length > 0){   
      $("[name='properties[Message For Engraving]']").parents('label').css('display','none');
      $("select option[value='No engraving required']").attr("selected",true);
      $(".template-product .bold_options .bold_option_set").find("input[type*='radio']").parents(".bold_option_set").addClass("checkbox-parent-div").children().removeClass("checkbox-parent-div");
    }

    if($("[name='properties[Message For Engraving]']").length > 0){   
      $("[name='properties[Complimentary Engraving?]']").parents('label').parents('.bold_option bold_option_dropdown').addClass('mesg112');
      $("[name='properties[Complimentary Engraving?]']").addClass('complimentary');
      $("[name='properties[Message For Engraving]']").parents('label').parents().addClass('mesg');

      $('[name="properties[Complimentary Engraving?]"]').on('change', function(){
        var select_value1 = $('[name="properties[Complimentary Engraving?]"]').val();
        if(select_value1 == 'No engraving required'){
          $("[name='properties[Message For Engraving]']").parents('label').css('display','none');
        } else {
          $("[name='properties[Message For Engraving]']").css('display','block'); 
          $("[name='properties[Message For Engraving]']").parents('label').css('display','block');
        }
      });

      $('select.complimentary option').filter(function() {
          return !this.value || $.trim(this.value).length == 0 || $.trim(this.text).length == 0;
      }).remove();
    }
  }
} catch(err) {}

// ==========================================
// 3. UI TWEAKS (HIDE CART ELEMENTS FOR KEEPSAKE BOX)
// ==========================================
document.addEventListener("DOMContentLoaded", function() {
  function hideKeepsakeCartElements() {
    // Target all table rows (<tr>) in the cart
    document.querySelectorAll('tr').forEach(row => {

      // Target ONLY the product title element (not the entire row text)
      let titleEl = row.querySelector('.line-item-info a.h6, .line-item-info a');

      if (titleEl) {
        let titleText = titleEl.textContent || titleEl.innerText;

        // Check if the actual product title includes 'personalised keepsake box'
        if (titleText.toLowerCase().includes('personalised keepsake box')) {

          // Hide the container holding the QTY selector and Remove button for this specific item
          let actionAreas = row.querySelectorAll('line-item-quantity');
          actionAreas.forEach(area => {
            area.style.display = 'none';
          });
        }
      }
    });
  }

  // Run the function on initial page load
  hideKeepsakeCartElements();

  // MutationObserver ensures elements stay hidden even if the cart updates dynamically via AJAX
  const cartObserver = new MutationObserver(() => {
    hideKeepsakeCartElements();
  });
  cartObserver.observe(document.body, { childList: true, subtree: true });
});




document.addEventListener(
  'click',
  function (event) {
    const searchTrigger = event.target.closest('[aria-controls^="header-search"]');

    if (!searchTrigger) {
      return;
    }

    const searchId = searchTrigger.getAttribute('aria-controls');
    const searchElement = document.getElementById(searchId);

    if (!searchElement || searchElement.open) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    window.scrollTo(0, 0);

    requestAnimationFrame(function () {
      if (typeof searchElement.show === 'function') {
        searchElement.show();
      } else {
        searchElement.setAttribute('open', '');
      }

      requestAnimationFrame(function () {
        const input = searchElement.querySelector('.header-search__input');

        if (input) {
          input.focus({ preventScroll: true });
        }
      });
    });
  },
  true
);

document.addEventListener('DOMContentLoaded', function () {
  const mobileInput = document.getElementById('mobile-number');

  if (!mobileInput) return;

  mobileInput.addEventListener('input', function () {
    this.value = this.value.replace(/\D/g, '');
  });
});

if (typeof $ !== 'undefined') {
$(document).on('click', 'label.special_instructions', function(e) {
  if (window.innerWidth > 749) {
    return;
  }

  var rect = this.getBoundingClientRect();
  var clickedQuestionIcon =
    e.clientX >= rect.right &&
    e.clientX <= rect.right + 45;

  if (clickedQuestionIcon) {
    e.preventDefault();
    e.stopPropagation();

    $(this).toggleClass('is-tooltip-active');
  }
});

$(document).on('click', function(e) {
  if (!$(e.target).closest('label.special_instructions').length) {
    $('label.special_instructions').removeClass('is-tooltip-active');
  }
});
}
// =====================================================
// GIFT CHECKBOX - SHOW / HIDE MOBILE NUMBER
// =====================================================
(function () {
  'use strict';

  function setupGiftCheckbox() {

    const checkbox = document.getElementById('purchasing_for_someone');
    const mobileField = document.querySelector(
      'p.cart-attribute__field.cart-INPUT__field'
    );

    if (!checkbox || !mobileField) {
      return;
    }

    checkbox.addEventListener('change', function () {

      if (this.checked) {

        this.value = 'Yes';
        this.setAttribute('value', 'Yes');

        mobileField.hidden = false;
        mobileField.removeAttribute('hidden');
        mobileField.style.display = '';

      } else {

        this.value = 'No';
        this.setAttribute('value', 'No');

        mobileField.hidden = true;
        mobileField.setAttribute('hidden', '');

      }

    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupGiftCheckbox);
  } else {
    setupGiftCheckbox();
  }

})();
// =====================================================
// GIFT CHECKOUT VALIDATION + CHECKOUT
// =====================================================

(function () {
  'use strict';

  document.addEventListener('click', function (event) {

    const checkoutButton = event.target.closest('#DirectCheckoutButton');

    if (!checkoutButton) {
      return;
    }

    // IMPORTANT:
    // Stop the click from reaching any other checkout handlers.
    event.preventDefault();
    event.stopImmediatePropagation();

    const checkbox = document.getElementById('purchasing_for_someone');
    const mobileInput = document.getElementById('mobile-number');
    const errorMessage = document.querySelector('.highlight-red');
    const cartForm = checkoutButton.closest('form.cart-page');

    console.log('[Gift Checkout] Button clicked');
    console.log('[Gift Checkout] Gift checked:', checkbox ? checkbox.checked : 'NOT FOUND');
    console.log('[Gift Checkout] Mobile:', mobileInput ? mobileInput.value : 'NOT FOUND');

    if (!checkbox || !mobileInput || !cartForm) {
      console.error('[Gift Checkout] Required elements not found');
      return;
    }

    // =================================================
    // CASE 1: GIFT CHECKED + MOBILE EMPTY
    // =================================================

    if (checkbox.checked && !mobileInput.value.trim()) {

      console.log('[Gift Checkout] BLOCKED - Mobile number required');

      if (errorMessage) {
        errorMessage.textContent = 'Please Enter Mobile Number';
        errorMessage.hidden = false;
        errorMessage.style.display = 'block';
      }

      mobileInput.setAttribute('aria-invalid', 'true');

      mobileInput.focus();

      return;
    }

    // =================================================
    // VALIDATION PASSED
    // =================================================

    console.log('[Gift Checkout] Validation passed');

    if (errorMessage) {
      errorMessage.hidden = true;
      errorMessage.style.display = 'none';
    }

    mobileInput.removeAttribute('aria-invalid');

    // =================================================
    // SET CART ATTRIBUTES
    // =================================================

    const formData = new FormData();

    formData.append(
      'attributes[purchasing_for_someone]',
      checkbox.checked ? 'Yes' : 'No'
    );

    formData.append(
      'attributes[recipient_mobile_number]',
      checkbox.checked ? mobileInput.value.trim() : ''
    );

    // =================================================
    // SAVE CART ATTRIBUTES THEN GO TO CHECKOUT
    // =================================================

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: formData
    })
    .then(function (response) {

      if (!response.ok) {
        throw new Error('Unable to update cart');
      }

      return response.json();

    })
    .then(function () {

      console.log('[Gift Checkout] Cart attributes saved');

      // Finally go to Shopify checkout
      window.location.href = '/checkout';

    })
    .catch(function (error) {

      console.error('[Gift Checkout] Error:', error);

      // Don't silently fail.
      // Allow customer to retry.
      checkoutButton.disabled = false;

    });

  }, true);

})();


// =====================================================
// CHOCOLATE ADD-ON UI
// POPUP + SLIDER + QUANTITY
// ONLY FOR TEST PRODUCT
// NO CART / ADD-TO-CART FUNCTIONALITY
// =====================================================

(function () {
  'use strict';

  // ===================================================
  // SETUP CHOCOLATE UI
  // ===================================================

  function setupChocolateUI() {

    const addon =
      document.querySelector('[data-product-addon]');

    if (!addon) {
      return false;
    }


    // =================================================
    // CHECKBOX + QUANTITY
    // =================================================

    const checkbox =
      addon.querySelector(
        '[data-product-addon-checkbox]'
      );

    const quantityBox =
      addon.querySelector(
        '[data-chocolate-quantity]'
      );

    const quantityInput =
      addon.querySelector(
        '[data-chocolate-quantity-input]'
      );

    const minusButton =
      addon.querySelector(
        '[data-chocolate-quantity-minus]'
      );

    const plusButton =
      addon.querySelector(
        '[data-chocolate-quantity-plus]'
      );


    if (
      checkbox &&
      quantityBox &&
      quantityInput
    ) {

      // Prevent duplicate event listeners
      if (
        checkbox.dataset.chocolateUiReady !== 'true'
      ) {

        checkbox.dataset.chocolateUiReady = 'true';

        // ---------------------------------------------
        // CHECKBOX
        // ---------------------------------------------

        checkbox.addEventListener(
          'change',
          function () {

            if (this.checked) {

              quantityBox.hidden = false;

              quantityInput.value = 1;

              this.dataset.addonQuantity = 1;

            } else {

              quantityBox.hidden = true;

              quantityInput.value = 1;

              this.dataset.addonQuantity = 1;

            }

          }
        );


        // ---------------------------------------------
        // MINUS
        // ---------------------------------------------

        if (minusButton) {

          minusButton.addEventListener(
            'click',
            function (event) {

              event.preventDefault();
              event.stopPropagation();

              let quantity =
                parseInt(
                  quantityInput.value,
                  10
                ) || 1;

              quantity =
                Math.max(
                  1,
                  quantity - 1
                );

              quantityInput.value =
                quantity;

              checkbox.dataset.addonQuantity =
                quantity;

            }
          );

        }


        // ---------------------------------------------
        // PLUS
        // ---------------------------------------------

        if (plusButton) {

          plusButton.addEventListener(
            'click',
            function (event) {

              event.preventDefault();
              event.stopPropagation();

              let quantity =
                parseInt(
                  quantityInput.value,
                  10
                ) || 1;

              quantity++;

              quantityInput.value =
                quantity;

              checkbox.dataset.addonQuantity =
                quantity;

            }
          );

        }


        // ---------------------------------------------
        // QUANTITY INPUT
        // ---------------------------------------------

        quantityInput.addEventListener(
          'change',
          function () {

            let quantity =
              parseInt(
                this.value,
                10
              ) || 1;

            quantity =
              Math.max(
                1,
                quantity
              );

            this.value =
              quantity;

            checkbox.dataset.addonQuantity =
              quantity;

          }
        );

      }

    }


    // =================================================
    // POPUP
    // =================================================

    const popup =
      document.querySelector(
        '[data-chocolate-popup]'
      );

    if (!popup) {
      return true;
    }


    const openButtons =
      document.querySelectorAll(
        '[data-chocolate-popup-open]'
      );


    // Prevent duplicate popup listeners
    if (
      popup.dataset.chocolatePopupReady === 'true'
    ) {
      return true;
    }

    popup.dataset.chocolatePopupReady = 'true';


    // =================================================
    // OPEN POPUP
    // =================================================

    openButtons.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function (event) {

            event.preventDefault();
            event.stopPropagation();

            popup.hidden = false;

            document.documentElement.style.overflow =
              'hidden';

          }
        );

      }
    );


    // =================================================
    // CLOSE POPUP
    // =================================================

    popup
      .querySelectorAll(
        '[data-chocolate-popup-close]'
      )
      .forEach(
        function (element) {

          element.addEventListener(
            'click',
            function (event) {

              event.preventDefault();

              popup.hidden = true;

              document.documentElement.style.overflow =
                '';

            }
          );

        }
      );


    // =================================================
    // ESC KEY
    // =================================================

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape' &&
          !popup.hidden
        ) {

          popup.hidden = true;

          document.documentElement.style.overflow =
            '';

        }

      }
    );


    // =================================================
    // IMAGE SLIDER
    // =================================================

    const slides =
      popup.querySelectorAll(
        '[data-chocolate-slide]'
      );

    const previousButton =
      popup.querySelector(
        '[data-chocolate-prev]'
      );

    const nextButton =
      popup.querySelector(
        '[data-chocolate-next]'
      );

    const currentCounter =
      popup.querySelector(
        '[data-chocolate-current]'
      );


    let currentSlide = 0;


    function showSlide(index) {

      if (!slides.length) {
        return;
      }


      // Loop to last image
      if (index < 0) {
        index = slides.length - 1;
      }


      // Loop to first image
      if (index >= slides.length) {
        index = 0;
      }


      slides.forEach(
        function (slide, slideIndex) {

          slide.classList.toggle(
            'is-active',
            slideIndex === index
          );

        }
      );


      currentSlide = index;


      if (currentCounter) {

        currentCounter.textContent =
          currentSlide + 1;

      }

    }


    // =================================================
    // PREVIOUS IMAGE
    // =================================================

    if (previousButton) {

      previousButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          showSlide(
            currentSlide - 1
          );

        }
      );

    }


    // =================================================
    // NEXT IMAGE
    // =================================================

    if (nextButton) {

      nextButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          showSlide(
            currentSlide + 1
          );

        }
      );

    }


    // =================================================
    // HIDE ARROWS IF ONLY ONE IMAGE
    // =================================================

    if (slides.length <= 1) {

      if (previousButton) {
        previousButton.style.display = 'none';
      }

      if (nextButton) {
        nextButton.style.display = 'none';
      }

    }


    // Show first image
    showSlide(0);


    return true;
  }


  // ===================================================
  // WAIT FOR ADD-ON BLOCK
  // ===================================================

  let attempts = 0;

  const timer =
    setInterval(
      function () {

        attempts++;

        if (setupChocolateUI()) {

          clearInterval(timer);

        }

        if (attempts >= 30) {

          clearInterval(timer);

        }

      },
      300
    );

})();

// js for preventing accidental double-click / multi-click

(function () {
  'use strict';

  function getAddToCartForm(target) {
    return target && target.closest ? target.closest('form[action*="/cart/add"]') : null;
  }

  function getAddToCartSubmitButton(target) {
    return target && target.closest ? target.closest('form[action*="/cart/add"] [type="submit"]') : null;
  }

  function lockAddToCartForm(form) {
    form.dataset.customSubmitting = 'true';
    console.log('[Add to cart guard] First submit allowed. Locking add-to-cart form.');

    setTimeout(function () {
      Array.from(form.elements)
        .filter(function (element) {
          return element.type === 'submit';
        })
        .forEach(function (button) {
          button.dataset.customAtcLocked = 'true';
          button.setAttribute('aria-busy', 'true');
          button.disabled = true;
          button.style.pointerEvents = 'none';
        });
    }, 0);
  }

  function unlockAddToCartForm(form) {
    form.dataset.customSubmitting = 'false';
    console.log('[Add to cart guard] Unlocking add-to-cart form.');

    Array.from(form.elements)
      .filter(function (element) {
        return element.dataset.customAtcLocked === 'true';
      })
      .forEach(function (button) {
        button.removeAttribute('aria-busy');
        button.disabled = false;
        button.style.pointerEvents = '';
        delete button.dataset.customAtcLocked;
      });
  }

  // document.addEventListener(
  //   'click',
  //   function (event) {
  //     var submitButton = getAddToCartSubmitButton(event.target);

  //     if (!submitButton) {
  //       return;
  //     }

  //     var form = getAddToCartForm(submitButton);

  //     if (!form) {
  //       return;
  //     }

  //     if (form.dataset.customSubmitting === 'true') {
  //       console.log('[Add to cart guard] Duplicate click blocked.');
  //       event.preventDefault();
  //       event.stopImmediatePropagation();
  //       return;
  //     }

  //     if (!form.checkValidity()) {
  //       console.log('[Add to cart guard] Form is invalid. Click not locked.');
  //       return;
  //     }

  //     form.dataset.customSubmitting = 'true';
  //     form.dataset.customSubmitAllowed = 'true';
  //     console.log('[Add to cart guard] First click allowed. Blocking extra clicks.');
  //     submitButton.style.pointerEvents = 'none';
  //   },
  //   true
  // );

  document.addEventListener(
    'submit',
    function (event) {
      var form = getAddToCartForm(event.target);

      if (!form) {
        return;
      }

      if (form.dataset.customSubmitting === 'true') {
        if (form.dataset.customSubmitAllowed === 'true') {
          delete form.dataset.customSubmitAllowed;
          lockAddToCartForm(form);
          return;
        }

        console.log('[Add to cart guard] Duplicate submit blocked.');
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      if (!form.checkValidity()) {
        console.log('[Add to cart guard] Form is invalid. Submit not locked.');
        return;
      }

      lockAddToCartForm(form);
    },
    true
  );

  document.addEventListener(
    'cart:error',
    function (event) {
      var form = getAddToCartForm(event.target);

      if (form) {
        console.log('[Add to cart guard] Cart error detected.');
        unlockAddToCartForm(form);
      }
    },
    true
  );

  document.addEventListener(
    'variant:add',
    function (event) {
      var form = getAddToCartForm(event.target);

      if (form) {
        console.log('[Add to cart guard] Variant added without page redirect.');
        unlockAddToCartForm(form);
      }
    },
    true
  );
})();

// // Prevent cart quantity inputs from being manually set below 1.
(function () {
  'use strict';

  function getCartQuantityInput(target) {
    return target && target.closest ? target.closest('form.cart-page input[name="updates[]"]') : null;
  }

  function clampCartQuantity(input) {
    var quantity = parseInt(input.value, 10);

    if (!quantity || quantity < 1) {
      input.value = '1';
      console.log('[Cart quantity guard] Quantity changed back to 1.');
      return true;
    }

    return false;
  }

  document.addEventListener(
    'input',
    function (event) {
      var input = getCartQuantityInput(event.target);

      if (input) {
        clampCartQuantity(input);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var input = getCartQuantityInput(event.target);

      if (input) {
        clampCartQuantity(input);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var cartForm = event.target && event.target.closest ? event.target.closest('form.cart-page') : null;

      if (!cartForm) {
        return;
      }

      cartForm.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
        clampCartQuantity(input);
      });
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var quantityButton = event.target && event.target.closest ? event.target.closest('form.cart-page line-item-quantity .quantity-selector__button') : null;

      if (!quantityButton || !quantityButton.href || quantityButton.href.indexOf('quantity=0') === -1) {
        return;
      }

      console.log('[Cart quantity guard] Minus-to-zero click blocked. Use remove link to remove item.');
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );
})();